// Copyright (c) 2017 Deere & Company

import claimTypes from './claim-types';
import {combineReducers} from 'redux';
import favorites from '../../shared/components/favorites/reducers/favorites';
import links from './links';
import sapStatus from './sap-status';
import sessionExpiredModalVisibility from '../../shared/reducers/session-expired-modal-visibility';
import subClaimTypes from './sub-claim-types';

export const getCombinedReducers = () => combineReducers({
    claimTypes,
    favorites,
    links,
    sapStatus,
    sessionExpiredModalVisibility,
    subClaimTypes
});



// WEBPACK FOOTER //
// ./src/app/reducers/index.js